import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";

const useLaundry = () => {
  const {
    locale,
    ContactRef,
    aboutRef,
    defineRef,
    mainRef,
    joinRef,
    servicesRef,
  } = useBetween(useSelector((state) => state.useSharedLang));
  const userClassify = useSelector((state) => state.userClassify);
  const location = useLocation();

  const [clickUser, setClickUser] = useState(false);
  const onClickUser = () => {
    if (clickUser === false) {
      setClickUser(true);
      document.querySelector(".log-out-btn").style.visibility = "visible";
    } else {
      setClickUser(false);
      document.querySelector(".log-out-btn").style.visibility = "hidden";
    }
  };
  useEffect(() => {
    if (location.pathname.startsWith("/Navbar/Notifications", 0))
      clickTab(".Notification-nav-tab");
    else if (location.pathname.startsWith("/Navbar/Orders", 0))
      clickTab(".Orders-nav-tab");
    else if (location.pathname.startsWith("/Navbar/Settings", 0))
      clickTab(".Settings-nav-tab");

    // hide Hamburger

    const hamburger = document.querySelector(".hamburger");
    const navMenu = document.querySelector(".nav-buttons");

    document.addEventListener("click", function (event) {
      var Clicked = hamburger.contains(event.target);

      //If you click the hamburger do something

      //If NOT, do something else
      if (!Clicked) {
        hamburger.classList.remove("active");
        navMenu.classList.remove("active");
      }
    });

    const LanguageResponsive = document.querySelector(".nav-buttons");
    if (locale === "AR" || locale === "OR") {
      LanguageResponsive.style.left = "110px";
    } else {
      LanguageResponsive.style.left = "-110px";
    }
  }, [location.pathname, locale]);

  const clickHamburger = () => {
    const hamburger = document.querySelector(".hamburger");
    const navMenu = document.querySelector(".nav-buttons");

    hamburger.classList.toggle("active");
    navMenu.classList.toggle("active");
  };

  function clickTab(newClassName) {
    window.scrollTo(0, 0);
    var newTab = document.querySelector(newClassName);
    Array.from(document.querySelectorAll(".nav-button")).forEach(function (
      val
    ) {
      if (!val.classList.contains(newClassName)) {
        val.style.fontWeight = "normal";
        val.style.borderBottom = "none";
      }
    });
    newTab.style.fontWeight = "bold";
    newTab.style.borderBottom = "solid 1px";

    const hamburger = document.querySelector(".hamburger");
    const navMenu = document.querySelector(".nav-buttons");
    hamburger.classList.remove("active");
    navMenu.classList.remove("active");
  }

  return {
    clickHamburger,
    clickTab,
    locale,
    userClassify,
    location,
    clickUser,
    setClickUser,
    onClickUser,
    ContactRef,
    aboutRef,
    defineRef,
    mainRef,
    joinRef,
    servicesRef,
  };
};

export default useLaundry;
